// jiboomba URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/betwin";
// const BASE_URL = "https://iccpanel.com/api/v1/betwin";
//
// const BASE_URL = "https://staging.syscorp.in/api/v1/test";

const BASE_URL = "https://iccpanel.com/api/v1/ekuwabet";
// const BASE_URL = "https://iccpanel.com/api/v1/ekuwabet";

export default BASE_URL;
